import { z } from 'zod';
import { ImageOptimizationSchema, PaginationSchema } from './common.js';

/**
 * Search endpoint Zod schemas for Polymarket Gamma API
 */

export const PublicSearchParamsSchema = z.object({
  q: z.string(),
  cache: z.boolean().optional(),
  events_status: z.string().optional(),
  limit_per_type: z.number().optional(),
  page: z.number().optional(),
  events_tag: z.array(z.string()).optional(),
  keep_closed_markets: z.number().optional(),
  sort: z.string().optional(),
  ascending: z.boolean().optional(),
  search_tags: z.boolean().optional(),
  search_profiles: z.boolean().optional(),
  recurrence: z.string().optional(),
  exclude_tag_id: z.array(z.number()).optional(),
  optimized: z.boolean().optional(),
});

export const ProfileSchema = z.object({
  id: z.string(),
  name: z.string().nullable().optional(),
  user: z.number().nullable().optional(),
  referral: z.string().nullable().optional(),
  createdBy: z.number().nullable().optional(),
  updatedBy: z.number().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
  utmSource: z.string().nullable().optional(),
  utmMedium: z.string().nullable().optional(),
  utmCampaign: z.string().nullable().optional(),
  utmContent: z.string().nullable().optional(),
  utmTerm: z.string().nullable().optional(),
  walletActivated: z.boolean().nullable().optional(),
  pseudonym: z.string().nullable().optional(),
  displayUsernamePublic: z.boolean().nullable().optional(),
  profileImage: z.string().nullable().optional(),
  bio: z.string().nullable().optional(),
  proxyWallet: z.string().nullable().optional(),
  profileImageOptimized: ImageOptimizationSchema.optional(),
  isCloseOnly: z.boolean().nullable().optional(),
  isCertReq: z.boolean().nullable().optional(),
  certReqDate: z.string().nullable().optional(),
});

export const SearchTagSchema = z.object({
  id: z.string(),
  label: z.string(),
  slug: z.string(),
  event_count: z.number(),
});

// Forward declarations for circular dependencies
const EventSchema = z.unknown();

export const SearchRequestSchema = PublicSearchParamsSchema;

export const SearchResponseSchema = z.object({
  events: z.array(EventSchema).nullable().optional(),
  tags: z.array(SearchTagSchema).nullable().optional(),
  profiles: z.array(ProfileSchema).nullable().optional(),
  pagination: PaginationSchema,
});
